import { Route } from '@angular/router';

import { authGuardChild } from './common/guards/auth.guard';
import { ConfirmComponent } from './pages/confirm/page.component';
import { enrolGuardChild } from './common/guards/enrol.guard';
import { NotFoundComponent } from './pages/not-found/page.component';
import { STRINGS } from './services/constants';
import { VerifyComponent } from './pages/verify/page.component';

export const ROUTES: Route[] = [
  {
    // TODO Remove. Use /confirm
    path: 'confirm-email',
    component: ConfirmComponent,
    title: STRINGS.HTML_TITLE,
  },
  {
    path: 'confirm',
    component: ConfirmComponent,
    title: STRINGS.HTML_TITLE,
  },
  {
    path: 'enrol',
    canActivateChild: [authGuardChild],
    loadChildren: () => import('./enrol/enrol.routes').then((m) => m.ROUTES),
    title: STRINGS.HTML_TITLE,
  },
  {
    path: 'signin',
    loadChildren: () => import('./signin/signin.routes').then((m) => m.ROUTES),
    title: STRINGS.HTML_TITLE,
  },
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.routes').then((m) => m.ROUTES),
    title: STRINGS.HTML_TITLE,
  },
  {
    path: 'unauthenticated',
    redirectTo: 'signin',
  },
  {
    path: 'verify',
    component: VerifyComponent,
    title: STRINGS.HTML_TITLE,
  },
  {
    path: '',
    canActivateChild: [authGuardChild, enrolGuardChild],
    loadChildren: () => import('./main/main.routes').then((m) => m.ROUTES),
    title: STRINGS.HTML_TITLE,
  },
  {
    path: '**',
    component: NotFoundComponent,
    title: STRINGS.HTML_TITLE,
  },
];
